export type DeviceConfigurationTabs = 'CONFIGURATIONS' | 'STATUS_TRACK' | 'CUSTOM_ALARMS';

export const DEVICE_CONFIGURATION_TABS: Record<DeviceConfigurationTabs, DeviceConfigurationTabs> = {
    CONFIGURATIONS: 'CONFIGURATIONS',
    STATUS_TRACK: 'STATUS_TRACK',
    CUSTOM_ALARMS: 'CUSTOM_ALARMS',
};

export const isDeviceConfigurationTab = (value: unknown): value is DeviceConfigurationTabs =>
    typeof value === 'string' && Object.values(DEVICE_CONFIGURATION_TABS).includes(value as DeviceConfigurationTabs);
